<div class="list-item-page">
  <tui-badged-content
    [style.color]="page?.showInMenu ? 'var(--tui-background-accent-1)' : ''"
    [tuiHint]="page?.showInMenu ? ('components.pagesListItem.labels.badgeHint' | translate) : ''"
    [style.--tui-radius.%]="50"
  >
    <!-- TODO: (Taiga UI migration) исправить! не корректно отображается -->
    <app-icon
      *ngIf="page?.showInMenu"
      tuiBadge
      tuiSlot="top"
      src="@tui.eye"
      [size]="'s'"
      [color]="'var(--tui-background-base)'"
    ></app-icon>
    <app-icon src="file-text" [size]="'30px'" [color]="'var(--unions-color-grey-75)'"></app-icon>
  </tui-badged-content>

  <div class="list-item-page__info">
    <span class="text_size-m text_color-01">
      {{ page?.title }}
    </span>
  </div>
</div>
